// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2ESre","notes":"Notes_notes__24fSg"};